export default __webpack_public_path__ + "static/media/junaid.83265708.png";